import { Branding } from "@/types/models/Branding";
import { routes } from "@/services/branding.service";
import useSWR from "swr";
import { fetcherV2 } from "@/services/api";

export function useBranding() {
  const { data, error, mutate } = useSWR(
    () => [routes.get, {}],
    fetcherV2<Branding>,
    {
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      suspense: false,
      shouldRetryOnError: false,
    }
  );

  return {
    branding: data,
    refresh: mutate,
    isLoading: !error && !data,
    isError: error,
  };
}
